import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Burger = ({ ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    <>
      <rect x='4' y='8' width='16' height='2' rx='1' fill='currentColor' />
      <rect x='4' y='14' width='16' height='2' rx='1' fill='currentColor' />
    </>
  </IconBase>
);
